<div class="hf-plans-page-wrapper">
  <div class="plan-section">
    <div class="header"  *ngIf="!showImg">
      <div class="title">
        {{info?.planDetails?.header?.title}}
      </div>
      <div class="sub-title">
        {{info?.planDetails?.header?.subTitle}}
      </div>
      <div class="desc">
        {{info?.planDetails?.header?.desc}}
      </div>
    </div>
    <div class="header" *ngIf="showImg && util.isMobile()" [ngClass]="{'benefits': showImg}">
      <div class="top-content">
        <div class="img-wrapper">
          <img [src]="info?.planDetails?.header?.img" alt="plan detail img" />
        </div>
        <div class="text">
          <div class="above">
            {{info?.planDetails?.header?.subscribeText}}
          </div>
          <div class="below" [innerHTML]="info?.planDetails?.header?.title2"></div>
        </div>
      </div>
      <div class="bottom-contentn">
        <div class="desc">
          {{info?.planDetails?.header?.desc}}
        </div>
      </div>
    </div>
    <div class="plan-content">
      <app-hf-plan-details-mob [showSlider]="util.isMobile()" [plans]="info?.plansMob" [amountData]="planAmountData" [recommended]="info?.recommended_plan"></app-hf-plan-details-mob>
    </div>
  </div>
  <app-hf-comments-section [info]="info"></app-hf-comments-section> 
  <app-hf-contact-section [info]="info"></app-hf-contact-section> 
</div>